<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		ControlsContainer,
		DoubleDeviceButton,
		DeviceButton,
		Text,
	} from '@Shelly/shelly-design-system';
	import { format_temp_units } from '../../../../../helpers/utilities';
	import { createEventDispatcher } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let units, value, mode;

	const dispatch = createEventDispatcher();
	const step = 0.5;
	const handle_count = (direction: 'up' | 'down') => {
		let _val = value;
		_val =
			direction === 'up'
				? Number(Number(_val) + step).toFixed(2)
				: Number(Number(_val) - step).toFixed(2);
		dispatch('temp_change', { value: _val });
	};
</script>

<ControlsContainer color={$showNewLayout ? 'color-1' : undefined}>
	<svelte:fragment slot="first">
		<DoubleDeviceButton
			aria-label={$format('button_label_decrease_increase_temperature', {
				default: 'Decrease / Increase Temperature',
			})}
			id="doubledevicebutton-ww76vg8"
			size="l"
			class="align-self-center"
			disabled={typeof mode === 'undefined'}
		>
			<DeviceButton
				aria-label={$format('button_label_decrease_temperature', {
					default: 'Decrease Temperature',
				})}
				id="devicebutton-3ewrgld"
				size="l"
				slot="buttonLeft"
				icon="fas fa-minus"
				variant="primary"
				on:touchstart={() => {}}
				on:click={() => handle_count('down')}
			/>
			<svelte:fragment slot="content">
				<Text styleType="controls-large" class="text-bold">
					{value}
				</Text>
				<Text styleType="controls-small">{`${format_temp_units(units)}`}</Text>
			</svelte:fragment>
			<DeviceButton
				id="devicebutton-i4ee4bf"
				aria-label={$format('button_label_increase_temperature', {
					default: 'Increase Temperature',
				})}
				size="l"
				slot="buttonRight"
				icon="fas fa-plus"
				variant="danger"
				on:touchstart={() => {}}
				on:click={() => handle_count('up')}
			/>
		</DoubleDeviceButton>
		<Text class="mt-s">{$format(`mode_${mode}`)}</Text>
	</svelte:fragment>
</ControlsContainer>
